<template>
  <div>
    <v-dialog
      max-width="420px"
      v-model="show"
      >
        <v-card>
          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">
            <v-card-title class="d-flex justify-space-between">
              <div class="loadflex"><span class="text-h6">Record Payment |</span>&nbsp;<span style="font-size:15px;color:darkgrey">{{ item.tolinkreceipt }}</span>&nbsp;&nbsp;<div class="load"><v-progress-circular
                    color="primary"
                    indeterminate
                    :size="18"
                    :width="3"
                    v-show="loader"></v-progress-circular></div></div>
            </v-card-title>

            <v-card-text>
                <v-container class="mt-0 mx-0 px-0 mb-0">
                  <v-row>
                    <v-col sm="12" md="6" cols="12">
                      <v-text-field
                          label="Amount*"
                          v-model="item.amount"
                          hide-details
                        ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="6"
                      >
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            label="Date*"
                            v-bind="attrs"
                            :value="timepickerdate"
                            v-on="on"
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          no-title
                          scrollable
                          @input="menu2 = false"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="#f9780d"
                            @click="menu2 = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="#f9780d"
                            @click="$refs.menu2.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="12"
                        md="6"
                      >
                        <v-autocomplete
                          :items="modes"
                          label="Select payment mode"
                          v-model="item.payment_mode_id"
                          item-text="name"
                          item-value="id"
                          :search-input.sync="paymentmodes"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col sm="12" md="6" cols="12">
                        <v-text-field
                            label="Reference no"
                            v-model="item.reference_no"
                            hide-details
                          ></v-text-field>
                      </v-col>
                  </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="default darken-1"
                  text
                  @click.stop="show = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="primary darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="submit"
                >
                  Submit
                </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
    </v-dialog>
  </div>
</template>

<style>
  .modal-payment{
    max-width:550px !important;
  }
</style>

<script>
import axios from 'axios'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import Vue from 'vue'

export default {
  name: 'linkinvoice',
  components: {
  },
  data: () => ({
    fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          menu2: false,
          date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        valid: true,
        paymentmodes: null,
        syncinvoices: null,
        isBusy: false,
        loading: false,
        disabled: false,
        item:{
           id: "",
           amount: "",
           payment_mode_id: '',
           reference_no: "",
           invoice_id: "",
           driverid: "",
           tolinkreceipt: "",
           date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
           _method:"patch"
        },
       modes: [],
       invoices: []
  }),
  methods: {

    selectedInvoice(id){
      let index = this.invoices.filter(item => item.id === id );
      this.item.amount = index[0].amount
    },

    async getData(){
        this.$store.state.componentloader = true
        await axios.get(`/driver/payment/modes/${this.item.driverid}`).then(response=>{
            this.$store.state.componentloader = false
            if(response.data.status == parseInt(200)) {
              this.modes = response.data.modes
              this.invoices = response.data.invoices
            }
        }).catch(error=>{
          this.$store.state.componentloader = false
          console.log(error)
        })
      },
    submit(){
      this.loading = true

      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      let fd = new FormData();
      fd.append('invoice_id',this.item.invoice_id)
      fd.append('driver_id',this.item.driverid)
      fd.append('payment_mode_id',this.item.payment_mode_id)
      fd.append('amount',this.item.amount)
      fd.append('reference_no',this.item.reference_no)
      fd.append('date',this.item.date)

      axios.post('/driver/link/receipts', fd, config).then(response=>{
          this.loading = false
        if(response.data.status == parseInt(200)) {

          let index = this.$store.state.driverinvoices.findIndex(data => data.id == response.data.invoice.id);
          if (index > -1) {
            this.$set(this.$store.state.driverinvoices, index, response.data.invoice);
          }

          this.$toast.success('Payment recorded successfully','Success',{position: 'topRight',timeout: 7000,})
          this.clear()
          this.show = false
        }
          
        })
        .catch(() => {
          this.loading = false
        })
    },

    clear() {
      this.item.payment_mode_id = null
      this.item.amount = ""
      this.item.reference_no = ""
      this.item.invoice_id = ""
      this.item.driverid = ""
      this.item.date = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd')
    }
  },
  watch: {
      data: function(newVal, oldVal) {
        if(newVal !== null) {
          this.item.id = newVal.id
          this.item.invoice_id = newVal.id
          this.item.driverid = newVal.driverid
          this.item.tolinkreceipt = newVal.tolinkreceipt
        }
      },
      show: function (newVal,oldVal) {
        if(newVal == true) {
          this.getData()
        }
      }
  },
  props: {
     value: Boolean
  },
  computed: {
    loader() {
      return this.$store.state.componentloader
    },
    data() {
      return this.$store.state.linkdriverinvoicedata
    },
    timepickerdate () {
      return this.date ? moment(this.date).format('Do MMM YYYY') : ''
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  },
  mounted() {
  },
  created() {}
}
</script>